import { useQuery } from 'react-query'
import { RegionRepository } from 'repository/region'
import { ReactText } from 'react'

export const useFetchCountries = () => {
  const { status, data: countries, error } = useQuery('countries', () =>
    RegionRepository.fetchCountries(),
  )

  return {
    status,
    countries,
    error,
  }
}

export const useFetchStates = (countryId?: string) => {
  const { status, data: states, error } = useQuery(!!countryId && ['states', { countryId }], () =>
    RegionRepository.fetchStates(countryId!),
  )

  return {
    status,
    states,
    error,
  }
}

export const useFetchMunicipalities = (stateId?: ReactText) => {
  const { status, data: municipalities, error } = useQuery(
    !!stateId && ['municipalities', { stateId }],
    () => RegionRepository.fetchMunicipalities(stateId!),
  )

  return {
    status,
    municipalities,
    error,
  }
}

export const useFetchAreas = (municipalityId?: ReactText) => {
  const { status, data: areas, error } = useQuery(
    !!municipalityId && ['areas', { municipalityId }],
    () => RegionRepository.fetchAreas(municipalityId!),
  )

  return {
    status,
    areas,
    error,
  }
}
